import React, { useState } from 'react';
import { Card, CardBody, CardFooter, Button, CardHeader } from 'reactstrap';
import styles from './ShopPlan.module.css';
import { ReactComponent as KitchenIcon } from '../../assets/images/range-refrigerator.svg';
import { ReactComponent as LaundryIcon } from '../../assets/images/washer-dryer.svg';
import { ReactComponent as TotalAppIcon } from '../../assets/images/kitchen-appliances.svg';
import classNames from 'classnames';
import { useMediaQuery } from 'react-responsive';
import PlanOptionModal from '../modals/PlanOptions/PlanOptions';
import { dataLayerPush } from '../../helpers';

const products = {
    kitchen: {
        image: <KitchenIcon />,
        title: 'Kitchen Appliances',
        monthly: null,
        yearly: null,
        includes: 'Refrigerator, Dishwasher and More',
        riskProfile: null,
        yearlyRiskProfile: null
    },
    laundry: {
        image: <LaundryIcon />,
        title: 'Laundry Appliances',
        monthly: null,
        yearly: null,
        includes: 'Washer and Dryer',
        riskProfile: null,
        yearlyRiskProfile: null
    },
    total: {
        image: <TotalAppIcon />,
        title: 'Total Appliance Bundle',
        monthly: null,
        yearly: null,
        includes: 'Kitchen, Laundry and Electrical',
        riskProfile: null,
        yearlyRiskProfile: null
    }
};

const MainPlanCard = ({
    product = 'kitchen',
    plan = 'monthly',
    activePlan,
    monthlyPrice,
    yearlyPrice,
    riskProfile,
    yearlyRiskProfile,
    onSelect
}) => {
    const isMobile = useMediaQuery({ query: '(max-width: 767px)' });
    const [showPlanOptionModal, setShowPlanOptionModal] = useState(false);
    const currentCardStyles = isMobile ? [styles.planCardMobile] : [styles.planCard];

    if (activePlan === product) {
        currentCardStyles.push(styles.activeCardStyle);
    }

    const handlePlanOptionModal = (event) => {
        event.preventDefault();

        const planPrice = plan === 'monthly' ? monthlyPrice : yearlyPrice;
        dataLayerPush(null, { ecommerce: null }); // clear last ecommerce data
        dataLayerPush('view_item', {
            ecommerce: {
                currency: 'USD',
                value: planPrice,
                paymentPlan: plan,
                items: [
                    {
                        item_id: product,
                        item_name: products[product].title,
                        item_category: 'primary_plan',
                        price: planPrice
                    }
                ]
            }
        });
        setShowPlanOptionModal(true);
    };

    const currentFooterStyles = [styles.planSelectBtn];
    if (activePlan === product) {
        currentFooterStyles.push(styles.activeFooterStyle);
    }

    if (riskProfile != null) {
        products[product]['monthly'] = monthlyPrice == null ? 0.0 : monthlyPrice;
        products[product]['yearly'] = yearlyPrice == null ? 0.0 : yearlyPrice;
        products[product].riskProfile = riskProfile;
        products[product].yearlyRiskProfile = yearlyRiskProfile;
    }

    /**
     * JSX HAS TWO VERSIONS. ONE MOBILE AND ONE DESKTOP.
     * REMEMBER TO MAKE CHANGES TO BOTH!!!
     */
    return (
        <>
            {isMobile ? (
                <Card className={currentCardStyles}>
                    <CardHeader
                        className={`${styles.planCardHeader} ${product !== 'total' ? styles.hiddenCardHeader : ''}`}
                    >
                        Bundle and Save
                    </CardHeader>
                    <CardBody className={styles.planDetailsMob}>
                        <span className={styles.assetIcon}>{products[product].image}</span>
                        <div>
                            <h2 className={classNames('h6', styles.addAsset)}>{products[product].title}</h2>
                            <p className={styles.addAsset}>
                                ${products[product][plan].toFixed(2)}/{plan === 'yearly' ? 'year' : 'month'}
                            </p>
                            <button
                                className='btnLink'
                                onClick={handlePlanOptionModal}
                            >
                                See Details
                            </button>
                        </div>
                    </CardBody>
                    <CardFooter
                        role='button'
                        className={classNames('btn btn-secondary', currentFooterStyles)}
                        onClick={() => onSelect(product, products[product], plan)}
                    >
                        {activePlan === product ? 'Plan Selected' : 'Select Plan'}
                    </CardFooter>
                </Card>
            ) : (
                // DESKTOP VERSION
                <Card className={currentCardStyles}>
                    <CardHeader
                        className={`${styles.planCardHeader} ${product !== 'total' ? styles.hiddenCardHeader : ''}`}
                    >
                        Bundle and Save
                    </CardHeader>
                    <CardBody className={styles.planDetails}>
                        <div className={styles.assetIcon}>{products[product].image}</div>
                        <div
                            className={classNames('h4 mb-0')}
                            style={{ textAlign: 'center' }}
                        >
                            {products[product].title}
                        </div>
                        <div className={styles.price}>
                            ${products[product][plan].toFixed(2)}/{plan === 'yearly' ? 'year' : 'month'}
                        </div>
                        <div>
                            <button
                                className='btnLink mt-3 mb-3'
                                onClick={handlePlanOptionModal}
                            >
                                See Details
                            </button>
                        </div>
                    </CardBody>
                    <Button
                        role='button'
                        className={classNames('btn btn-primary', currentFooterStyles)}
                        onClick={() => onSelect(product, products[product], plan)}
                    >
                        {activePlan === product ? 'Plan Selected' : 'Select Plan'}
                    </Button>
                </Card>
            )}

            {showPlanOptionModal && (
                <PlanOptionModal
                    isOpen={showPlanOptionModal}
                    centered={true}
                    toggle={() => setShowPlanOptionModal(!showPlanOptionModal)}
                    isHome={false}
                />
            )}
        </>
    );
};

export default MainPlanCard;
